module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp23_6000.a49ed07c.png";